import React from "react";
import {FieldViewProps} from "../../../render/view";

export default function FieldAttachment_ViewProperty(props: FieldViewProps) {

    const value = props.field.getViewValue(props.model)

    return (
        <div className="ui5-attachment-no-preview-small m-r-8 m-b-5">
            <div className="preview">
                <div className="ui5-ico-14 i5-attachment"/>
            </div>
            <div className="details">
                <div className="file-name ui5-txt-less-important-tiny txt-truncate">
                    {value.name}
                </div>
            </div>
        </div>
    )
}
